import { createRoot } from "react-dom/client";
import { createInertiaApp } from "@inertiajs/react";
import type { ReactNode } from "react";
import { TooltipProvider } from "@/components/Tooltip";
import { PortalShell } from "@/portal/shell/PortalShell";
import "../styles/application.css";

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob("../pages/**/*.tsx", { eager: true });
    const page = pages[`../pages/${name}.tsx`] as { default: any } | undefined;
    if (!page) throw new Error(`Inertia page not found: ${name}`);
    // Every page is wrapped in the PortalShell by default. A page can opt out /
    // override by setting its own `.layout` (e.g. auth screens).
    page.default.layout ??= (children: ReactNode) => (
      <PortalShell>{children}</PortalShell>
    );
    return page;
  },
  setup: ({ el, App, props }) => {
    createRoot(el).render(
      <TooltipProvider>
        <App {...props} />
      </TooltipProvider>,
    );
  },
});
